import React, { useEffect, useRef } from 'react'
import VoiceRecorder from './VoiceRecorder'
import FileAttacher from './FileAttacher'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import { type RootState } from '../../../../store/store'
import {
    removePendingMessage,
    sendMessage, setMessageDraft,
    setPendingMessage
} from '../../../../store/actionsCreators/chatActions'
import { setCurrentMessage } from '../../../../store/slices/chatSlice'
import { useParams } from 'react-router'
import ChatUtils from '../../../../functions/chats/ChatUtils'
import Icon from '../../../../app/icon/Icon'


const applyDynamicScaling = (): void => {
    if (window.visualViewport != null) {
        const innerWidth = window.innerWidth
        const visualViewport = Number(window.visualViewport.height)
        const aspectRatio = visualViewport / innerWidth;
        const baseWidth = 375;
        const baseHeight = Math.floor(375 * aspectRatio);
        const scale = (innerWidth / baseWidth);

        const body = document.body;
        const offsetLeft = (innerWidth - baseWidth * scale) / 2;
        const offsetTop = (visualViewport - baseHeight * scale) / 2;

        body.style.position = "absolute";
        body.style.width = `${baseWidth}px`;
        body.style.transform = `scale(${scale})`;
        body.style.transformOrigin = "top left";
        body.style.left = `${offsetLeft}px`;
        body.style.top = `${offsetTop}px`;
        body.style.maxHeight = `${baseHeight}px`;
        body.style.minHeight = `${baseHeight}px`;
        body.style.height = `${baseHeight}px`;
    }
};


interface ChatInputProps {
    bottomRef: React.RefObject<HTMLDivElement> | null
    isDesktop?: boolean
}

const ChatInput = ({ bottomRef, isDesktop = false }: ChatInputProps): JSX.Element => {

    const dispatch = useAppDispatch()
    const { id: chatID = '0' } = useParams()
    const { chat, currentMessage: message, pendingMessages } = useAppSelector((state: RootState) => state.chat)

    const inputRef = useRef<HTMLTextAreaElement>(null)
    const inputBarRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!isDesktop && window.visualViewport != null) {
            window.visualViewport.onresize = () => {
                applyDynamicScaling()
                document.getElementById('chat-wrapper')?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })

            }
        }
    }, [isDesktop])


    const scrollToBottom = (): void => {
        setTimeout(() => {
            bottomRef?.current?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    const adjustHeight = (e: any): void => {
        if (inputRef.current != null) {
            inputRef.current.style.height = "30px";
            const newHeight = Math.min(inputRef.current.scrollHeight, 30 * 2);
            inputRef.current.style.height = `${newHeight}px`;
        }
    };




    return (
        ChatUtils.isBSOBroadcast(chat)
            ? <></>
            : // issueOpen || !ChatUtils.isBSOSupport(chat) || currentUser?.id === process.env.REACT_APP_BSO_USER ?
            <div ref={inputBarRef} className={'w-100  d-flex align-items-end p-4 pb-8 gap-4 bg-white'}>
                <div className={'h-30px d-flex align-items-center'}>
                    <FileAttacher />
                </div>
                <textarea className={'scroll min-h-35px border-0 outline-0 w-100 p-2 bg-secondary rounded'}
                    id={'chat-input-textarea'}
                    ref={inputRef}
                    style={{
                        outline: 'none',
                        wordWrap: 'break-word',
                        resize: 'none',
                        height: '30px'
                    }}
                    value={message}
                    // onKeyUp={() => handleResize()}
                    onKeyDown={adjustHeight}
                    onChange={(e) => {
                        adjustHeight(e);
                        dispatch(setCurrentMessage(e.target.value))
                        setMessageDraft(e.target.value, +chatID)
                    }}
                />

                {
                    message.trim().length > 0
                        ? <div className={'h-30px d-flex align-items-center'}
                            onClick={() => {
                                const id = pendingMessages.length
                                dispatch(setPendingMessage(message, id))
                                dispatch(sendMessage(+chatID)).finally(() => {
                                    dispatch(removePendingMessage(id))
                                    scrollToBottom()
                                    if (inputRef != null && ((inputRef?.current) != null)) { inputRef?.current.focus() }
                                })
                            }}
                        >
                            <Icon name={'send'} className={'text-muted fs-3x'} />
                        </div>
                        : <div className={'h-30px d-flex align-items-center'}>
                            <VoiceRecorder />
                        </div>
                }
            </div>

    )
}

export default ChatInput




// const [ticketsActionsLoading, setTicketsActionsLoading] = useState(false)
// const userAgent = navigator.userAgent

// const supportTickets = chat.SupportTickets
// const issueOpen = supportTickets?.[supportTickets?.length - 1]?.TicketOpen === true

// const openSupportIssue = (type: 'viewing' | 'offer' | 'advertise' | 'profile' | 'units' | 'other') => () => {
//     if (!ticketsActionsLoading) {
//         setTicketsActionsLoading(true)
//         dispatch(handleSupportTicket({
//             isOpen: true,
//             chatID: chat.id ?? -1,
//             type
//         })).finally(() => {
//             setTicketsActionsLoading(false)
//             scrollToBottom()
//         })
//     }
// }


// :
// <div ref={inputBarRef} className={'w-100 d-flex align-items-end p-2 pb-8 gap-2 bg-white  '}
//     style={{ bottom: 0, zIndex: '100' }}
// >
//     <div className={'w-100 p-4 pb-8 gap-4 bg-white'}>
//         {!ticketsActionsLoading
//             ? <>
//                 <div className={'mb-4 d-flex justify-content-center align-items-center gap-2'}>
//                     <Icon name={'support_agent'} className={'fs-3x'} />
//                     <div className={'fw-bold fs-4'}>
//                         Open issue related to
//                     </div>
//                 </div>
//                 <div className={'row'}>
//                     <div className={'px-1 col-4 mb-2'}>
//                         <div className={'btn btn-bso btn-sm w-100'}
//                             onClick={openSupportIssue('viewing')}
//                         >
//                             Viewing
//                         </div>
//                     </div>
//                     <div className={'px-1 col-4 mb-2'}>
//                         <div className={'btn btn-bso btn-sm w-100'}
//                             onClick={openSupportIssue('offer')}
//                         >
//                             Offer
//                         </div>
//                     </div>
//                     <div className={'px-1 col-4 mb-2'}>
//                         <div className={'btn btn-bso btn-sm w-100'}
//                             onClick={openSupportIssue('advertise')}
//                         >
//                             Advertise
//                         </div>
//                     </div>
//                     <div className={'px-1 col-4 mb-2'}>
//                         <div className={'btn btn-bso btn-sm w-100'}
//                             onClick={openSupportIssue('profile')}
//                         >
//                             Profile
//                         </div>
//                     </div>
//                     <div className={'px-1 col-4 mb-2'}>
//                         <div className={'btn btn-bso btn-sm w-100'}
//                             onClick={openSupportIssue('units')}
//                         >
//                             Units
//                         </div>
//                     </div>
//                     <div className={'px-1 col-4 mb-2'}>
//                         <div className={'btn btn-bso btn-sm w-100'}
//                             onClick={openSupportIssue('other')}
//                         >
//                             Other issue
//                         </div>
//                     </div>
//                 </div>
//             </>
//             : <div className={'d-flex justify-content-center'}>
//                 <div className={'spinner-border'} />
//             </div>
//         }
//     </div>
// </div>
